var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "toggleable-text"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(!_vm.text ? _vm.placeholder : _vm.hideTextOverflow ? _vm.computedText : _vm.text) + " ")]), _c('br'), _vm.isTextOverflow ? _c('label', {
    staticClass: "toggleable-text-toggle",
    on: {
      "click": _vm.toggleFullText
    }
  }, [_vm._v(" " + _vm._s(_vm.hideTextOverflow ? _vm.$t('form.toggle.read-more') : _vm.$t('form.toggle.read-less')) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }